import { ProductPosition } from "shared/types/ProductPosition"
import { LinkProps } from "shared/ui/link/Link"

import { getProductPositionHref } from "entities/product-positions/lib/getProductPositionHref"
import { useExternalDimensioningRestore } from "entities/products/model/useExternalDimensioningRestore"
import { useLink } from "features/navigation/model/useLink"

interface UseProductPositionLinkArgs {
  productPosition: ProductPosition | null | undefined
}

export function useProductPositionLink({
  productPosition
}: UseProductPositionLinkArgs): LinkProps {
  const linkProps = useLink({
    path: getProductPositionHref(productPosition)
  })

  const { data } = useExternalDimensioningRestore({
    externalDimensioningResult: productPosition?.dimensioning
  })

  return {
    ...linkProps,
    disabled: productPosition?.dimensioning ? !data : false
  }
}
